// Chrome strings (EN / ID) for the Scenes menu. Content strings never
// go through here — they live in the data files.
import { config } from '../../content/config.js';

export const L = config.ui;
export const LANGS = ['en', 'id'];
